<app-results-events-group-mobile [eventResults]="filteredEventResults" [scoreGroups]="evenResultsAndScoreGroups.scoreGroups"></app-results-events-group-mobile>
